import "core-js/modules/es.number.constructor";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

var AppSelector = /*#__PURE__*/function (_Vue) {
  _inherits(AppSelector, _Vue);

  var _super = _createSuper(AppSelector);

  function AppSelector() {
    var _this;

    _classCallCheck(this, AppSelector);

    _this = _super.apply(this, arguments);
    _this.model = '';
    _this.rules = {
      required: function required(value) {
        return !!value || '不能为空！';
      }
    };
    return _this;
  }

  _createClass(AppSelector, [{
    key: "mounted",
    value: function mounted() {
      this.model = this.value === -1 ? '' : this.items[this.value];
    }
  }, {
    key: "onValueChanged",
    value: function onValueChanged(val) {
      this.model = val === -1 ? '' : this.items[val];
    }
  }, {
    key: "valueChangedHandler",
    value: function valueChangedHandler(val, index) {
      this.model = val;
      return index;
    }
  }, {
    key: "submit",
    value: function submit() {}
  }]);

  return AppSelector;
}(Vue);

__decorate([Prop(Number)], AppSelector.prototype, "value", void 0);

__decorate([Prop(String)], AppSelector.prototype, "label", void 0);

__decorate([Prop({
  type: String
})], AppSelector.prototype, "placeholder", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppSelector.prototype, "required", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 289
})], AppSelector.prototype, "width", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 36
})], AppSelector.prototype, "height", void 0);

__decorate([Prop({
  type: Array
})], AppSelector.prototype, "items", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppSelector.prototype, "disabled", void 0);

__decorate([Watch('value')], AppSelector.prototype, "onValueChanged", null);

__decorate([Emit('input')], AppSelector.prototype, "valueChangedHandler", null);

__decorate([Emit()], AppSelector.prototype, "submit", null);

AppSelector = __decorate([Component], AppSelector);
export default AppSelector;